import React, { useState, useEffect } from "react";
import {
  Steps,
  Button,
  Row,
  Col,
  Card,
  message,
  Modal,
  Input,
  Form,
} from "antd";
import {
  CheckCircleFilled, // For completed steps in the header
  SaveOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "./ReportBuilder.css"; // Make sure this CSS is linked
import ReportAssistant from "./components/ReportAssistant";
import StepsContent from "./components/StepsContent";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import { useNavigate } from "react-router-dom";

const { Step } = Steps;

const ReportBuilder = ({ fetchAllReports, selectedReportForEdit, onBack }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedTables, setSelectedTables] = useState([]); // Start with no selection
  const [selectedFields, setSelectedFields] = useState([]);
  const [fieldsToDisplay, setFieldsToDisplay] = useState([]);
  const [filters, setFilters] = useState([]);
  const [selectedChartType, setSelectedChartType] = useState("table");
  const [hasRunReport, setHasRunReport] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saveModalVisible, setSaveModalVisible] = useState(false);
  const [reportForm] = Form.useForm();
  const [selectedReport, setSelectedReport] = useState(null);
  const [logic, setLogic] = useState("");
  const navigate = useNavigate();
  const [aggregrationType, setAggregrationType] = useState(null);
  const [isDetail, setIsDetail] = useState(true);
  const [is_collapsed, setIs_collapsed] = useState(false);
  const [sortBy, setSortBy] = useState(null);

  useEffect(() => {
    console.log("selectedReportForEdit changed:", selectedReportForEdit);

    if (selectedReportForEdit) {
      setSelectedReport(selectedReportForEdit);
      // Pre-fill selected tables
      if (selectedReportForEdit.model) {
        setSelectedTables([selectedReportForEdit.model]);
      }
      // Pre-fill selected fields
      const preSelectedFields = [];
      (selectedReportForEdit.group_fields || []).forEach((field) => {
        preSelectedFields.push({
          name: `${selectedReportForEdit.model}.${field}`,
          type: "Dimension",
        });
      });
      (selectedReportForEdit.aggregation_fields || []).forEach((field) => {
        preSelectedFields.push({
          name: `${selectedReportForEdit.model}.${field}`,
          type: "Measure",
        });
      });
      setSelectedFields(preSelectedFields);
      // Pre-fill fields to display
      setFieldsToDisplay(selectedReportForEdit.fields_to_display || []);
      console.log("selected edit for filters", selectedReportForEdit.filters);
      // Pre-fill filters
      // const preFilters = [];
      // const filterEntries = Object.entries(selectedReportForEdit.filters || {});
      // filterEntries.forEach(([_, filter]) => {
      //   if (filter.field) {
      //     const operator = typeof filter.value === 'object' ? Object.keys(filter.value)[0] : null;
      //     const value = typeof filter.value === 'object' ? filter.value[operator] : filter.value;
      //     preFilters.push({
      //       field: filter.field,
      //       operator: operator || "", // Set to empty string if operator is null
      //       value: value,
      //     });
      //   }
      // });
      // setFilters(selectedReportForEdit.filters);
      // Pre-fill chart type

      setSelectedChartType(selectedReportForEdit.chart_type || "table");

      console.log(
        "Pre-filling aggregrationType:",
        selectedReportForEdit.aggregation_type,
      );
      console.log("Pre-filling isDetail:", selectedReportForEdit.is_detailed);

      setAggregrationType(selectedReportForEdit.aggregation_type);

      setIsDetail(selectedReportForEdit.is_detailed);
      setIs_collapsed(selectedReportForEdit.is_collapsed || false);
      setSortBy(selectedReportForEdit.sort_by || null);
      // Pre-fill logic
      setLogic(selectedReportForEdit.filter_logic || "");

      // Set hasRunReport to true to allow saving immediately
      // setHasRunReport(true);
      // Pre-fill report form
      reportForm.setFieldsValue({
        name: selectedReportForEdit.name,
        description: selectedReportForEdit.description,
      });
    }
  }, [selectedReportForEdit, reportForm]);

  const next = () => {
    setCurrentStep(currentStep + 1);
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleExit = () => {
    navigate(-1);
  };

  const handleSelectTable = (tableId) => {
    setSelectedTables([tableId]); // Only allow one table selection
  };

  const handleRemoveTable = (tableId) => {
    setSelectedTables(selectedTables.filter((id) => id !== tableId));
  };

  const handleAddField = (field) => {
    const selectedTableName =
      selectedTables.length > 0 ? selectedTables[0] : "Object";
    const fieldName = `${selectedTableName}.${field.fieldName}`;
    if (!selectedFields.some((f) => f.name === fieldName)) {
      const fieldType = field.fieldType === "measure" ? "Measure" : "Dimension";
      setSelectedFields([
        ...selectedFields,
        {
          name: fieldName,
          type: fieldType,
        },
      ]);
    }
  };

  const handleRemoveField = (fieldName) => {
    setSelectedFields(
      selectedFields.filter((field) => field.name !== fieldName),
    );
  };

  const handleFieldsToDisplayChange = (value) => {
    setFieldsToDisplay(value);
  };

  // const handleAddFilter = () => {
  //   setFilters([...filters, { field: '', condition: 'equals', value: '' }]);
  // };

  // const handleRemoveFilter = (index) => {
  //   setFilters(filters.filter((_, i) => i !== index));
  // };

  // const handleFilterChange = (index, key, value) => {
  //   const newFilters = [...filters];
  //   newFilters[index][key] = value;
  //   setFilters(newFilters);
  // };

  const handleSelectChartType = (chartType) => {
    setSelectedChartType(chartType);
    console.log("Selected chart type:", chartType);
  };

  const handleRunReport = () => {
    fetchReportData();
  };

  const fetchReportData = async () => {
    setLoading(true);

    console.log("aggregrationType", aggregrationType);
    console.log("isDetail", isDetail);
    // Prepare filters object same as in handleSubmit
    const filterObj = filters.reduce((acc, filter, index) => {
      if (filter.field) {
        let value;

        // If filter.value is already an object (like {$ne: 'CURRENT_USER'}), use it directly
        if (typeof filter.value === "object" && filter.value !== null) {
          value = filter.value;
        }
        // If operator exists and value is empty/undefined, create operator object
        else if (
          filter.operator &&
          (filter.value === undefined || filter.value === "")
        ) {
          value = { [filter.operator]: "" };
        }
        // If operator exists and value is not empty, create operator object with value
        else if (
          filter.operator &&
          filter.value !== undefined &&
          filter.value !== ""
        ) {
          value = { [filter.operator]: filter.value };
        }
        // Default case: use value as is (or empty string if undefined)
        else {
          value = filter.value === undefined ? "" : filter.value;
        }

        acc[index + 1] = {
          field: filter.field,
          value: value,
        };
      }
      return acc;
    }, {});

    let filterLogic = "";
    const filterObjKeys = Object.keys(filterObj);
    if (filterObjKeys.length === 1) {
      filterLogic = "1";
    } else if (filterObjKeys.length > 1) {
      filterLogic = logic || "";
    }

    // Separate dimension and measure fields and remove table prefix
    const dimensionFields = selectedFields
      .filter((field) => field.type === "Dimension")
      .map((field) => field.name.split(".").pop()); // Remove table prefix, keep only field name
    const measureFields = selectedFields
      .filter((field) => field.type === "Measure")
      .map((field) => field.name.split(".").pop()); // Remove table prefix, keep only field name

    const sortByFields = sortBy ? sortBy.split(".").pop() : null; // Remove table prefix if sortBy is set

    const body = {
      mt_report: {
        model: selectedTables.length > 0 ? selectedTables[0] : "",
        name: selectedReport ? selectedReport.name : "Ad-hoc Report",
        filters: filterObj || {},
        chart_type: selectedChartType || "table",
        fields_to_display: fieldsToDisplay || [], // Use fieldsToDisplay from Step 2
        group_fields: dimensionFields,
        filter_logic: filterLogic,
        aggregation_fields: measureFields,
        aggregation_type: aggregrationType,
        is_detailed: isDetail,
        is_collapsed: is_collapsed,
        sort_by: sortByFields,
      },
    };

    console.log("Request Body:", JSON.stringify(body));
    try {
      const apiService = new ApiService(
        `${BASE_URL}/report_preview`,
        { "Content-Type": "application/json" },
        "POST",
        body,
      );
      const response = await apiService.makeCall();
      console.log("Report data response:", response);

      // Check if data array is empty
      if (!response?.data || response.data.length === 0) {
        setReportData([]);
        setRowData([]);
        setHasRunReport(true);
        message.info("No data available for this report");
        return;
      }

      const flattenedRowData = response?.data.map((record) => {
        const flattened = {};

        Object.entries(record).forEach(([key, value]) => {
          // Keep untouched by default
          flattened[key] = value;

          // Skip if value is null
          if (value === null) return;

          // Is this field a lookup AND used in group_fields?
          const isLookupField = fields?.find(
            (f) => f.name === key && f.type === "lookup",
          );
          const isGroupedField = response?.report?.group_fields?.includes(key);

          if (
            isLookupField &&
            isGroupedField &&
            typeof value === "object" &&
            value?.Name
          ) {
            flattened[key] = value.Name; // Flatten only if in group_by
            flattened[`${key}_object`] = value;
          }
        });

        return flattened;
      });

      setRowData(flattenedRowData);
      setReportData(flattenedRowData);
      setHasRunReport(true);
      message.success("Report generated successfully!");
    } catch (error) {
      console.error("Error fetching report data:", error);
      message.error(
        "Error fetching report data: " + (error.error || error.message),
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSaveReport = () => {
    setSaveModalVisible(true);
  };

  const handleSubmit = async (values) => {
    const filterObj = filters.reduce((acc, filter, index) => {
      if (filter.field) {
        let value;

        // If filter.value is already an object (like {$ne: 'CURRENT_USER'}), use it directly
        if (typeof filter.value === "object" && filter.value !== null) {
          value = filter.value;
        }
        // If operator exists and value is empty/undefined, create operator object
        else if (
          filter.operator &&
          (filter.value === undefined || filter.value === "")
        ) {
          value = { [filter.operator]: "" };
        }
        // If operator exists and value is not empty, create operator object with value
        else if (
          filter.operator &&
          filter.value !== undefined &&
          filter.value !== ""
        ) {
          value = { [filter.operator]: filter.value };
        }
        // Default case: use value as is (or empty string if undefined)
        else {
          value = filter.value === undefined ? "" : filter.value;
        }

        acc[index + 1] = {
          field: filter.field,
          value: value,
        };
      }
      return acc;
    }, {});
    console.log("filterObj", filterObj);

    let filterLogic = "";
    const filterObjKeys = Object.keys(filterObj);
    if (filterObjKeys.length === 1) {
      filterLogic = "1";
    } else if (filterObjKeys.length > 1) {
      filterLogic = logic || "";
    }

    console.log("filterLogic", filterLogic);

    // Separate dimension and measure fields and remove table prefix
    const dimensionFields = selectedFields
      .filter((field) => field.type === "Dimension")
      .map((field) => field.name.split(".").pop()); // Remove table prefix, keep only field name
    const measureFields = selectedFields
      .filter((field) => field.type === "Measure")
      .map((field) => field.name.split(".").pop()); // Remove table prefix, keep only field name

    const sortByFields = sortBy ? sortBy.split(".").pop() : null; // Remove table prefix if sortBy is set

    const body = {
      mt_report: {
        model: selectedTables.length > 0 ? selectedTables[0] : values.model,
        name: values.name,
        description: values.description,
        filters: filterObj || {},
        chart_type: selectedChartType || values.chart_type,
        fields_to_display: fieldsToDisplay || [], // Use fieldsToDisplay from Step 2
        group_fields: dimensionFields,
        filter_logic: filterLogic,
        aggregation_fields: measureFields,
        aggregation_type: aggregrationType,
        is_detailed: isDetail,
        is_collapsed: is_collapsed,
        sort_by: sortByFields,
      },
    };

    console.log("Request Body:", JSON.stringify(body));

    let apiService;

    if (selectedReport?._id) {
      apiService = new ApiService(
        `${BASE_URL}/mt_reports/${selectedReport._id}`,
        { "Content-Type": "application/json" },
        "PATCH",
        body,
      );
    } else {
      apiService = new ApiService(
        `${BASE_URL}/mt_reports`,
        { "Content-Type": "application/json" },
        "POST",
        body,
      );
    }

    // Set loading to true before the API call
    setLoading(true);

    try {
      const response = await apiService.makeCall();
      message.success("Report saved successfully!");
      reportForm.resetFields();
      setSaveModalVisible(false);
      // Reset other fields if needed
      setSelectedFields([]);
      setFilters([]);
      setLogic("");
      setSelectedReport(null);
      setSelectedTables([]);
      setFieldsToDisplay([]);
      setSelectedChartType("table");
      setHasRunReport(false);
      setReportData([]);
      setRowData([]);
      setFields([]);
      setAggregrationType(null);
      setIsDetail(false);
      setIs_collapsed(false);
      setSortBy(null);
    } catch (error) {
      message.error("Failed to save the report.");
      console.error("Save error:", error);
    } finally {
      // Set loading to false after the API call completes
      setLoading(false);
    }
  };

  // Calculate group fields for report preview
  const reportGroupFields = selectedFields
    .filter((field) => field.type === "Dimension")
    .map((field) => field.name.split(".").pop()); // Remove table prefix, keep only field name

  // Calculate aggregation fields for report preview
  const reportAggregationFields = selectedFields
    .filter((field) => field.type === "Measure")
    .map((field) => field.name.split(".").pop()); // Remove table prefix, keep only field name

  const steps = [
    {
      title: "Data Sources",
      description: "Choose Model",
      content: (
        <StepsContent
          step={1}
          selectedTables={selectedTables}
          onSelectTable={handleSelectTable}
          onRemoveTable={handleRemoveTable}
        />
      ),
    },
    {
      title: "Fields",
      description: "Add dimensions & measures",
      content: (
        <StepsContent
          step={2}
          selectedFields={selectedFields}
          onRemoveField={handleRemoveField}
          onAddField={handleAddField}
          selectedTables={selectedTables}
          fieldsToDisplay={fieldsToDisplay}
          onFieldsToDisplayChange={handleFieldsToDisplayChange}
          setAggregrationType={setAggregrationType}
          aggregrationType={aggregrationType}
          isDetail={isDetail}
          setIsDetail={setIsDetail}
          is_collapsed={is_collapsed}
          setIs_collapsed={setIs_collapsed}
          sortBy={sortBy}
          setSortBy={setSortBy}
        />
      ),
    },
    {
      title: "Filters",
      description: "Customize criteria",
      content: (
        <StepsContent
          step={3}
          filters={filters}
          setFilters={setFilters}
          selectedTables={selectedTables}
          logic={logic}
          setLogic={setLogic}
          selectedFilters={selectedReportForEdit?.filters}
        />
      ),
    },
    {
      title: "Chart",
      description: "Configure visualization",
      content: (
        <StepsContent
          step={4}
          selectedChartType={selectedChartType}
          onSelectChartType={handleSelectChartType}
        />
      ),
    },
    {
      title: "Preview",
      description: "View & save report",
      content: (
        <StepsContent
          step={5}
          hasRunReport={hasRunReport}
          reportData={reportData}
          loading={loading}
          fieldsToDisplay={fieldsToDisplay}
          selectedTables={selectedTables}
          fields={fields}
          selectedFields={selectedFields}
          reportGroupFields={reportGroupFields}
          reportAggregationFields={reportAggregationFields}
          selectedChartType={selectedChartType}
        />
      ),
    },
  ];

  return (
    <Card className="report-builder-container">
      {/* Top Header and Run Report Button */}
      <div className="header-bar">
        <div className="header-title-section">
          <h2 style={{ fontSize: "28px", fontWeight: "bold", color: "#333" }}>
            Report Builder
          </h2>
          <p>
            Build reports like a pro - select data sources, add fields,
            configure filters, and visualize
          </p>
        </div>
        <div style={{ display: "flex", gap: "12px", marginTop: "16px" }}>
          <Button
            type="default"
            size="large"
            onClick={() => {
              if (selectedReportForEdit) {
                onBack(); // editing → go back normally
              } else {
                navigate("/setup/Reports"); // creating new report
              }
            }}
            style={{ marginRight: "12px" }}
          >
            Back to All Reports
          </Button>

          <Button
            type="default"
            icon={<SaveOutlined />}
            onClick={handleSaveReport}
            size="large"
            disabled={!(currentStep >= 3)}
          >
            Save Report
          </Button>
          <Button
            type="primary"
            onClick={handleRunReport}
            size="large"
            loading={loading}
            disabled={currentStep !== 4 - 1} // Enable only at Step 4
          >
            Run Report
          </Button>
        </div>
      </div>

      {/* Steps Timeline */}
      <Steps
        current={currentStep}
        labelPlacement="vertical"
        className="steps-timeline"
      >
        {steps.map((item, index) => (
          <Step
            key={item.title}
            title={item.title}
            description={item.description}
            icon={currentStep > index ? <CheckCircleFilled /> : null} // Checkmark for completed steps
          />
        ))}
      </Steps>

      {/* Main Content Area */}
      <Row gutter={24} className="main-content-row">
        <Col span={18} className="main-content-col">
          <div className="step-content-box">{steps[currentStep].content}</div>
        </Col>

        {/* Report Assistant Sidebar */}
        <Col span={6} className="sidebar-col">
          <ReportAssistant
            currentStep={currentStep}
            selectedFields={selectedFields}
            filters={filters}
          />
        </Col>
      </Row>

      {/* Navigation Buttons */}
      <div
        className="navigation-buttons"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 0",
          borderTop: "1px solid #f0f0f0",
          marginTop: "20px",
        }}
      >
        {currentStep === 0 ? (
          <Button
            onClick={handleExit}
            size="large"
            icon={<ArrowLeftOutlined />}
          >
            Exit
          </Button>
        ) : (
          <Button onClick={prev} size="large">
            Previous
          </Button>
        )}
        <div style={{ display: "flex", gap: "12px" }}>
          {currentStep < steps.length - 1 && (
            <Button type="primary" onClick={next} size="large">
              Next
            </Button>
          )}
          {currentStep === steps.length - 1 && (
            <Button
              type="primary"
              disabled={!hasRunReport}
              size="large"
              onClick={handleSaveReport}
            >
              Completed
            </Button>
          )}
        </div>
      </div>

      {/* Save Report Modal */}
      <Modal
        title="Save Report"
        open={saveModalVisible}
        onCancel={() => setSaveModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setSaveModalVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={loading}
            onClick={() => reportForm.submit()}
          >
            Save Report
          </Button>,
        ]}
      >
        <Form form={reportForm} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="name"
            label="Report Name"
            rules={[{ required: true, message: "Please enter a report name" }]}
          >
            <Input placeholder="Enter report name" />
          </Form.Item>

          <Form.Item name="description" label="Description">
            <Input.TextArea
              placeholder="Enter report description (optional)"
              rows={3}
            />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

export default ReportBuilder;
